import { useEffect } from "react"
import { analytics } from "./firebase"
import PasswordReset from "./PasswordReset"
import Placeholder from "./Placeholder"
export default function App() {
  const routeName = window.location.pathname.split("/")[1] || "home"

  useEffect(() => {
    analytics.logScreen(routeName)
  }, [routeName])

  switch (routeName) {
    case "password-reset":
      return <PasswordReset />
       default:
      return <Placeholder />
  }
}
